<template>
    <div class="_content">
		<template v-if="!fromVerify" >
			<div class="success-status" v-if="success">
				<img src="~@/imgs/image/success.png" alt="" />
				<span class="verify_title">核销成功</span>
			</div>
			<div class="success-status" v-else-if="!success">
				<img src="~@/imgs/image/fail.png" alt="" />
				<span class="verify_title">核销失败</span>
                <span class="Verify_message">{{this.Message}}</span>
			</div>
		</template>
        <div class="detail_cont">
            <div class="order_car">
                <div class="title" v-if="fromVerify">
                    <span class="order_title"> {{isEdit? todayListInfo.serviceProviderName:todayListInfo.secondClassName}}</span>
                    <span class="order_name">服务名称</span>
                </div>
                <van-cell-group>
                    <van-cell v-if="!fromVerify" title="服务名称"  :value="this.todayListInfo.secondClassName||todayListInfo.serviceProviderName" />
                    <van-cell title="消费码" :value="this.todayListInfo.verificationCode" />
                    <van-cell v-if="scsShow || !success  " title="订单编号" :value="this.todayListInfo.orderNo" />
                    <template v-if="success">
                        <van-cell title="订单收入" v-if="!hidePrice" @click="hidePrice=true">
                            <template #default>
                                <span style="color: #006EEF">点击查看</span>
                            </template>
                        </van-cell>
                        <van-cell title="订单收入" v-else :value="this.todayListInfo.orderPrice" />
                    </template>
                    <van-cell v-if="scsShow || !success" title="完成时间" :value="this.todayListInfo.createdTime" />
                    <van-cell title="手机号码" :value="this.todayListInfo.userPhone"  v-if="fromVerify && !isEdit"/>
                    <van-cell title="手机号码" :value="this.todayListInfo.mobile"  v-else-if="isEdit"/>
                    <van-cell v-if="this.todayListInfo.userCar" title="车牌号码" :value="this.todayListInfo.userCar" />
                </van-cell-group>
            </div>

            <div class="verify-img">
                <div class="img-title bottom-line">
                    <span>核销图片</span>
                    <span @click="toVerifyUpload" style="color:#2875FF">修改</span>
                </div>
                <div class="uploadImg-box">
                    <div v-for="(item,index) in imgList" :key="index" class="upload" > <!--v-upload="{onUpload: upload , vin:false, index:`${index}-${item.type}`, refresh:true}"-->
                        <img :src="item.val" class="uploadImg" alt=""  @click="showImagePreview(item.val)" />
                        <p>{{item.title}}</p>
                    </div>
                </div>
            </div>

            <div class="tips">
                <span>如有疑问</span>
                <span>请咨询客服  <i v-call="'400-176-8848'">400-176-8848</i> </span>
            </div>
        </div>
    </div>
</template>
<script>
import config from '@/configs/config'
import { ImagePreview } from "vant"

export default {
    data() {
        return {
			todayListInfo: {},
			success: '', // 订单列表来的1
			scsShow: '', // 核销来的1
            isEdit: '',
			fromVerify: false, // true订单来的 false核销来的
            hidePrice: false,
            Message: '', // 失败信息
            imgList: []
        }
    },
    created() {
		this.init()
    },
    methods: {
        showImagePreview(val) {
            ImagePreview({
                images: [val], // 要预览的图片数组（支持多张）
                 closeable: true, // 显示关闭按钮
                 closeOnPopstate: true, // 浏览器后退时关闭预览
            });
        },
        init() {
            this.todayListInfo = (this.options && this.options.ListInfo) ? this.options.ListInfo : (JSON.parse(tuhu.sessionStorage.getItem('shopOrderDetail') || null) || {})

            this.Message = this.todayListInfo.Message || ''

            this.scsShow = tuhu.getParam('scsShow') || ''

            this.success = tuhu.getParam('success') || ''

            let result = (location.href.indexOf('success') === -1)

            this.fromVerify = result

            let imgList = [
                {
                    type: 'vehicleWorkingPhoto',
                    title: '显露车牌及车店一体的作业中照片',
                    val: ''
                },
                {
                    type: 'vehicleOilPhoto',
                    title: '使用的机油与车辆合影照片',
                    val: ''
                },
                {
                    type: 'beforeWorkPhoto',
                    title: '作业前漆面照片',
                    val: ''
                },
                {
                    type: 'workingPhoto',
                    title: '作业中照片',
                    val: ''
                },
                {
                    type: 'afterWorkPhoto',
                    title: '作业后漆面照片',
                    val: ''
                },
                {
                    type: 'workOrderPhoto',
                    title: '工单照片',
                    val: ''
                },
                {
                    type: 'elseWorkPhoto',
                    title: '其他照片',
                    val: ''
                },
                {
                    type: 'carLiftPhoto',
                    title: '车辆在起升架上的照片',
                    val: ''
                },
                {
                    type: 'hoodOpenPhoto',
                    title: '引擎盖打开的照片',
                    val: ''
                },
                {
                    type: 'electronicCheckReport',
                    title: '安全检测电子检测报告',
                    val: ''
                },
                {
                    type: 'signature',
                    title: '签名图片',
                    val: ''
                },
                {
                    type: 'puttyingPhoto',
                    title: '刮腻子照片',
                    val: ''
                },
                {
                    type: 'vinPhoto',
                    title: '车架号图片',
                    val: ''
                }
            ]
            this.isEdit = tuhu.getParam('isEdit') || ''
            // 核销界面
            if(!this.fromVerify || this.isEdit) {
                const checkPhoto = this.todayListInfo.checkPhoto
                imgList.forEach(item => {
                    if (checkPhoto[item.type]) {
                        item.val = checkPhoto[item.type]
                    }
                })
            }else{ //订单详情界面
                imgList.forEach(item => {
                    if (this.todayListInfo[item.type]) {
                        item.val = this.todayListInfo[item.type]
                    }
                })
            }
            this.imgList = imgList.filter(item => item.val)
        },
        async upload(val) {
            let index = val.index.split('-')[0]
            let type = val.index.split('-')[1]

            this.$set(this.imgList[index], 'val', val.data)
            
            let params = {

                shopBillId: this.todayListInfo.billId,

                [type]: val.data

            }

            const res = await tuhu.fetch(`${config.apis.UPDATAE_WRITEOFF_PIC}`, {

                method: 'post',

                body: JSON.stringify(params)

            })

            if (res && res.code === '200') {

                tuhu.toast(res.message || '更换成功')
            }

        },
        //跳转修改核销信息
        async toVerifyUpload() {
			const shopInfo = tuhu.store.state.currentShopInfo
			const shopId =  shopInfo ? shopInfo.shopId : JSON.parse(localStorage.getItem("_xk_user_key"))['shopId']
            const code = this.todayListInfo.verificationCode
            //获取回显 
            const res = await tuhu.fetch(`${config.apis.GET_SAFE_MESSAGE}?writeOffCode=${code}`)
            if (res && res.code === '200') {
                tuhu.sessionStorage.setItem('upDetail', JSON.stringify(res.data))
                tuhu.navigateTo({
                    url: '/pages/editVerifyImg/index',
                    data: {
                        uploadDetail: res.data,
                    },
                    query: {
                        sId: shopId,
                        vCode: code
                    }
                })
            } else {
                tuhu.toast(res.message || '网络错误')
            }
		},
    }
}
</script>

<style lang="less" scoped>
    ._content{
        display: flex;
        flex-direction: column;
    }
    .detail_cont{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: .5rem;
    }
    .order_car{
        width: 100%;
        background: #FFF;
        border-radius: .3rem;
            padding: 0 0 .75rem 0;
        .title{
            width: 100%;
            height: 7rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            >span:nth-child(1) {
                font-size: 1rem;
            }
        }
    }
    .verify-img {
        width: 100%;
        border-radius: .3rem;
        background: #fff;
        margin-top: .5rem;
        .img-title {
            display:flex;
            justify-content: space-between;
            padding: .5rem .75rem;
        }
        .uploadImg-box {
            padding:10px;
            display: grid;
            grid-template-columns: repeat(3, 1fr); /* 3列 */
            gap: 10px; /* 图片间距 */
            .upload {
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                position: relative;
                margin: 1rem 0 1rem 0;
                >img {
                    border-radius: .3rem;
                    width: 4.5rem;
                    height: 4.5rem;
                }
                >p {
                    display:block;
                    height: 30px;
                    padding: .25rem 0;
                    text-align: center;
                }
                >span {
                    position: absolute;
                    top: 1.6rem;
                    left: 1.6rem;
                    font-size: .7rem;
                    color: #fff;
                }
            }
        }
    }
    .tips{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 2rem;
        >span:nth-child(2) i{
            color: rgb(55,149,240);
        }
    }
</style>
<style lang="less" scoped>
.success-status {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
	img {
		width: 3rem;
		height: 3rem;
	}
}
.Verify_message {
    color: red;
    margin-top: 1rem;
    font-size: .8rem;
}
.verify_title {
   font-size: 1.1rem;
   margin-top: .5rem;
}
.van-cell{
    .van-cell__title{
        // width: 8rem;
        flex: 4;
        color: #666;
    }
    .van-cell__value {
        flex: 6;
        text-align: left;
        color: #666;
        width: 10rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
}
.order_title{
    font-weight: 600;
}
.order_name{
    font-size: .8rem ;
    color: #666;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderDetail/index.vue